
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const FeederPageHeader: React.FC = () => {
  return (
    <header className="py-4 mb-8">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-semibold">Publiseringskø</h2>
          <p className="text-gray-600 mt-2">
            Intervjuer markert for publiseringskøen
          </p>
        </div>
        <div className="flex space-x-3">
          <Link to="/publish-history">
            <Button className="flex items-center gap-2">
              Se publiseringshistorikk
            </Button>
          </Link>
          <Link to="/interview-management">
            <Button className="flex items-center gap-2">
              <ArrowLeft className="h-4 w-4" />
              Tilbake til intervjuadministrasjon
            </Button>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default FeederPageHeader;
